import React from "react";

const shortcuts = [
  { key: "Ctrl + Alt + T", label: "Patho. Tst Val" },
  { key: "Ctrl + Alt + R", label: "Radio. Tst Val" },
  { key: "Ctrl + M", label: "Lab Mul." },
  { key: "Ctrl + B", label: "Bill Charges" },
  { key: "Ctrl + F1", label: "Medical Store Sale" },
  { key: "Ctrl + F5", label: "OPD Reg" },
  { key: "Ctrl + F6", label: "IPD Reg" },
  { key: "Ctrl + F7", label: "Lab" },
  { key: "Ctrl + F8", label: "Receipt" },
  { key: "Ctrl + F9", label: "P History" },
  { key: "Ctrl + F11", label: "OPD Charges" },
  { key: "Ctrl + F12", label: "P Status" }
];

const Footer = () => {
  return (
    <footer
      style={{
        position: "fixed",
        bottom: 0,
        left: 0,
        width: "100%",
        background: "#1e293b",
        color: "#fff",
        zIndex: 1000,
        borderTop: "2px solid #0f172a"
      }}
    >
      {/* 🔹 Shortcuts */}
      <div
        style={{
          display: "flex",
          flexWrap: "wrap", // ✅ wrap instead of scroll
          justifyContent: "center",
          padding: "4px 8px",
          fontSize: "9px",
          gap: "6px"
        }}
      >
        {shortcuts.map((item, index) =>
          <div
            key={index}
            style={{
              display: "flex",
              alignItems: "center"
            }}
          >
            <span
              style={{
                background: "#334155",
                padding: "2px 5px",
                borderRadius: "4px",
                fontWeight: "bold",
                marginRight: "1px",
                fontSize: "9px"
              }}
            >
              {item.key}
            </span>
            <span>
              {item.label}
            </span>
          </div>
        )}
      </div>

      {/* 🔹 Copyright */}
      <div
        style={{
          borderTop: "1px solid #334155",
          padding: "3px",
          fontSize: "11px",
          textAlign: "center"
        }}
      >
        © {new Date().getFullYear()}{" "}
        <a
          href="https://azsmenterprises.com/"
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: "#38bdf8", textDecoration: "none" }}
        >
          AZSM Enterprises
        </a>{" "}
        All rights reserved.
      </div>
    </footer>
  );
};

export default Footer;
